import React, {  useEffect, useState,useRef,useContext  } from "react";
import ReactGA from 'react-ga4';
import queryString from 'query-string';
import { Link  } from 'react-router-dom';
import Lang from '../lang/translations';






export default function Ko() {
    
    const query = queryString.parse(window.location.search);
    var errorMsg = ""
    errorMsg = query.errorMsg;


    
    return (<div className="all-container bg-light pianiAbbonamentoPage">
    <div className="container filters-no-padding" role="main">
        <div className="row">
            <div className="col-md-7 col-12 col-centered">
                <div className="jumbotron text-center">
                        <img className="imgVip" src="/img/angry.jpg"/>
                        <h1 className="display-3">{Lang( {"w": "ops","page": "ko"} )}</h1>
                        <p className="lead">{Lang( {"w": "qualcosa_storto","page": "ko"} )}</p>
                        <hr/>
                    
                        <p className="lead">
                            <Link to="/purchase" className="btn btn-primary btn-sm" role="button">{Lang( {"w": "bottone_indietro","page": "ko"} )}</Link>
                        </p>
                </div>
            </div>
        </div>
    </div>
</div>
            )

}